export const USER_READABLE_ACCEPTED_TYPES = <const>['mp4', 'mov', 'webm', 'm4v'];
export const ACCEPTED_TYPES_AS_CONST = <const>['video/quicktime', 'video/webm', 'video/mp4', 'video/x-m4v', 'video/*'];
export const ACCEPTED_TYPES = ['video/quicktime', 'video/webm', 'video/mp4', 'video/x-m4v', 'video/*'];

const isAcceptedVideoType = (type: string): boolean => {
  return ACCEPTED_TYPES.includes(type);
};

export default isAcceptedVideoType;
